function isMobile() {
  return window.innerWidth < 768
}

export default isMobile
